import React from 'react';
import { NavLink } from 'react-router-dom';

const AdminSidebarNav = ({ sections, sidebarOpen, onNavigate }) => {
  return (
    <nav className="flex-1 overflow-y-auto px-3 py-4">
      {sections.map((section, sectionIndex) => (
        <div key={section.title} className="mb-6">
          {sidebarOpen && (
            <h3 className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-500">
              {section.title}
            </h3>
          )}
          {!sidebarOpen && sectionIndex > 0 && (
            <div className="mb-3 border-t border-gray-200" />
          )}
          <ul className="space-y-1">
            {section.items.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === '/admin-profile'}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    `flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                      sidebarOpen ? 'gap-3' : 'justify-center'
                    } ${
                      isActive
                        ? 'bg-red-50 text-red-600'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                  title={!sidebarOpen ? item.name : undefined}
                >
                  {({ isActive }) => (
                    <>
                      <item.icon
                        className="h-5 w-5 shrink-0"
                        strokeWidth={isActive ? 2 : 1.5}
                      />
                      {sidebarOpen && <span>{item.name}</span>}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};

export default AdminSidebarNav;
